const MENU_NAMESPACE = "MENU";
export const UPDATE_MENU_OPEN: string = `${MENU_NAMESPACE}/UPDATE_MENU_OPEN`;
